export default "__VITE_ASSET__CJefrP19__"